import axios from 'axios';

export const withCancelToken = (fn) => {
  const source = axios.CancelToken.source();
  const promise = fn(source);

  promise.cancel = () => {
    source.cancel();
  };

  return promise;
};
